<template>
  <div class="shareRinking">
    <van-dialog
      v-model="shareRinkDialog"
      :lazy-render="true"
      :showConfirmButton="false"
      :close-on-click-overlay="true"
      class="share_rinking_dialog"
      :before-close="handleClose"
    >
      <div class="share_box" ref="shareBox">
        <div class="empty"></div>
        <div class="user_head">
          <img class="user_head_img" :src="rank.headUrl"/>
          <img
            crossOrigin="anonymous"
            class="user_head_bg"
            :src="
              require(`@/assets/ranking/share_top${rank.ranking || 1}_bg.webp`)
            "
            alt=""
          />
        </div>
        <div
          class="share_rinking_content"
          :style="{ background: backgroundColos[(rank.ranking || 1) - 1] }"
        >
          <div class="share_info_name" ref="shareDemo">{{ rank.name }}</div>
          <div :class="['share_info_ranking', language]" v-html="resultTipsText"></div>
          <div class="share_ranking_icon">
            <img
              :src="
                require(`@/assets/ranking/ranking_top${rank.ranking ||
                  1}_big.webp`)
              "
              alt=""
            />
          </div>
          <div
            :class="['share_btn', language === 'ug' && 'share_btn_ug']"
            @click="shareToDynamic"
          >
            {{ $t('分享到动态') }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { getOssTmpAuthInfo } from '@/api'
import COS from 'cos-js-sdk-v5'
import { appFunc_LiveRankShareDynamic } from '@/utils/bridge'

export default {
  name: 'ShareRinkDialog',
  props: {
    ranking: {
      default: () => ({ name: '1111', ranking: 1, type: 0 })
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    resultTipsText() {
      const result = this.rankList.map(item => {
        return this.$t('xx第xx名', {
          value: item.ranking || 0,
          name: this.tabList[item.type || 0].name
        })
      })     
      return this.$t('恭喜你获得上周xx', {str: result.join('、')})
    }
  },
  created() {
    this.language = this.$route.query.language || 'ug'
  },
  data() {
    return {
      rank: {},
      rankList: [],
      language: 'ug',
      shareRinkDialog: false,
      tabList: [
        { name: this.$t('魅力榜') },
        { name: this.$t('豪气榜') },
        { name: this.$t('游戏榜') }
      ],
      backgroundColos: [
        'linear-gradient(180deg, #fff1af 0%, #fff9de 100%)',
        'linear-gradient( 180deg, #AFEEFF 0%, #DAF7FF 100%)',
        'linear-gradient( 180deg, #FFDFAF 0%, #FFF0DA 100%)'
      ],
    }
  },
  watch: {
    isShow: {
      handler(val) {
        this.shareRinkDialog = val
      },
      immediate: true
    },
    ranking: {
      handler(val) {
        this.rankList = Array.isArray(val) ? val : [val]
        this.rank = Array.isArray(val) ? this.rankList[0] : val
        console.log(this.rankList, 'this.rankList')
      },
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:isShow', false)
    },
    shareToDynamic() {
      this.$forceUpdate()
      this.$nextTick(() => {
        setTimeout(() => {
          this.capture()
        }, 300)
      })
    },
    capture() {
      const element = this.$refs.shareBox
      
      html2canvas(element, {
        useCORS: true,
        backgroundColor: null, // Transparent background
        scale: window.devicePixelRatio < 2 ? 2 : window.devicePixelRatio, // Better quality
        scrollY: 0, // Prevent scroll offset issues
        scrollX: 0,
        onclone: (clonedDoc) => {
          // Fix for text shifting upwards - ensure styles are computed correctly in clone
          const nameNode = clonedDoc.querySelector('.share_info_name')
          const rankNode = clonedDoc.querySelector('.share_info_ranking')
          if (nameNode) nameNode.style.lineHeight = '1.2' 
          if (rankNode) rankNode.style.lineHeight = '1.2'
        }
      }).then(canvas => {
        canvas.toBlob(blob => {
           if (blob) {
             const file = new File([blob], 'ranking.png', { type: 'image/png' })
             this.uploadShareImg({ file: file })
           } else {
             console.error('Canvas to Blob failed')
           }
        }, 'image/png')
      }).catch(error => {
        console.error('html2canvas error:', error)
      })
    },
    // 上传图片
    async uploadShareImg(file) {
      const fileName = file.file.name // 保存文件名
      const fileName2 = fileName.split('.') // 对文件名进行切割
      const filename = Math.random()
        .toString(36)
        .substr(2)
      const renameFile = new File([file.file], filename + '.' + fileName2[1], {
        type: file.file.type
      })

      // 创建COS实例  获取签名
      const { data } = await getOssTmpAuthInfo()
      const { host, bucket, region } = data
      const cos = new COS({
        // 必选参数
        getAuthorization: (options, callback) => {
          const obj = {
            TmpSecretId: data.tmpSecretId,
            TmpSecretKey: data.tmpSecretKey,
            XCosSecurityToken: data.sessionToken,
            StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.expiredTime // 时间戳，单位秒，如：1580000900
          }
          callback(obj)
        }
      })

      cos.putObject(
        {
          Bucket: bucket /* 存储桶名称 */,
          Region: region /* 存储桶所在地域 */,
          Key:
            process.env.VUE_APP_COSIMG + renameFile.name /* 存储所在文件夹 */,
          StorageClass: 'STANDARD',
          Body: file.file, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData))
          }
        },
        (err, data) => {
          if (data.statusCode === 200) {
            console.log(host + data.Location.substring(43))
            const result = this.rankList.map(item => {
              return this.$t('xx第xx名', {
                value: item.ranking || 0,
                name: this.tabList[item.type || 0].name
              })
            })     
            appFunc_LiveRankShareDynamic({
              url: host + data.Location.substring(43),
              rank: this.rank.ranking,
              type: this.rank.type,
              copyText: this.$t('我获得上周xx', {str: result.join('、')}),
            })
            this.handleClose()
          } else {
            console.log(err)
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.share_box {
  .empty {
    height: 80px;
  }
}
.share_rinking_content {
  //   background: linear-gradient(180deg, #fff1af 0%, #fff9de 100%);
  border-radius: 20px;
  box-sizing: border-box;
  padding: 90px 28px 16px;
  text-align: center;
  .share_info_name {
    font-weight: 500;
    font-size: 20px;
    color: #f43030;
    line-height: normal;
  }
  .share_info_ranking {
    font-weight: 500;
    font-size: 16px;
    color: #181818;
    padding: 12px 0;
    line-height: normal;
  }
  .share_ranking_icon {
    padding-bottom: 32px;
    img {
      width: 84px;
      height: 84px;
    }
  }
  .share_btn {
    display: inline-block;
    width: 145px;
    height: 44px;
    line-height: 44px;
    background-color: #C498FE;
    border-radius: 23px;
    font-size: 16px;
    color: #ffffff;
    white-space: nowrap;
  }
  .share_btn_ug {
    font-size: 14px;
  }
}
.user_head {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  .user_head_img {
    width: 100px;
    height: 100px;
    background: #d9d9d9;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #f9ba35;
    border-radius: 50%;
  }
  .user_head_bg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 290px;
    height: 170px;
    z-index: -1;
  }
}
::v-deep .share_rinking_dialog {
  overflow: initial;
  background-color: transparent;
}
.share_info_ranking:nth-of-type(3) {
  padding: 0;
}
</style>
